import React, { useEffect, useState } from 'react'
import logo from '../../superadmin/assets/invoice_logo.png';
import { Button, Stack, Typography } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import '../../superadmin/styles/pages/auth.css';
import { useNavigate, useParams } from 'react-router-dom';
import instance from '../../utils/Api';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import './pdfTemplate.css';
import Topbar from '../layouts/Topbar';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Image from '../../utils/getImage';

const TAX_RATE = 0.07;

function ccyFormat(num) {
  return `${num.toFixed(2)}`;
}

function priceRow(qty, unit) {
  return qty * unit;
}

function createRow(desc, qty, unit) {
  const price = priceRow(qty, unit);
  return { desc, qty, unit, price };
}

function subtotal(items) {
  return items.map(({ price }) => price).reduce((sum, i) => sum + i, 0);
}

const rows = [
  createRow('Paperclips (Box)', 100, 1.15),
  createRow('Paper (Case)', 10, 45.99),
  createRow('Waste Basket', 2, 17.99),
];

const invoiceSubtotal = subtotal(rows);
const invoiceTaxes = TAX_RATE * invoiceSubtotal;
const invoiceTotal = invoiceTaxes + invoiceSubtotal;


const PdfTemplate = () => {
  const { id } = useParams();
  const [data, setData] = useState();
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();
  const [url, setUrl] = useState(null);


  function priceRow(qty, unit) {
    return qty * unit;
  }

  function createRow(desc, qty, unit) {
    const price = priceRow(qty, unit);
    return { desc, qty, unit, price };
  }

  function subtotal(items) {
    return items.map(({ price }) => price).reduce((sum, i) => sum + i, 0);
  }
  const invoiceSubtotal = subtotal(products);
  const getAttence = async () => {
    try {
      const response = await instance.get(`/Transactions/getTransactionById?transaction_id=${id}`);
      console.log(response);
      setData(response.data.data);

      const products = response?.data?.data?.products?.map((data) =>
        createRow(
          data?.product_id?.product_name,
          data?.quantity,
          data?.price
        )
      );

      setProducts(products);
    } catch (error) {
      console.log(error);
    }
  };
  const loadPdf = async (data) => {
    // setLoading(true); // Start showing the skeleton while fetching
    try {
      const response = await instance.get(
        `/S3Image/getSignedpdf?image=${data?.invoice_pdf}`
      );
      setUrl(response.data.image);
    } catch (error) {
      console.error("Error loading image:", error);
      // setLoading(false); // Stop loading on error
    }
  };

  useEffect(() => {
    getAttence();
  }, [id]);
  useEffect(() => {
    loadPdf(data);
  }, [data]);
  function downloadPDF(url, filename = 'download.pdf') {
    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.blob();
      })
      .then(blob => {
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        link.href = url;
        link.download = filename;

        document.body.appendChild(link);
        link.click();

        // Cleanup
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      })
      .catch(error => {
        console.error('Error downloading the PDF:', error);
      });
  }

  console.log("data",data);

  return (
    <>
      <Topbar />
      <div className='invoice-main'>
        <section className='main'>
          <div className='employees-text inventory-backtn'>
            <div>
              <Typography variant='h5'>Transaction Invoice</Typography>
              {/* <Typography variant='h6' >School Name: <span>{schoolname}</span></Typography> */}
            </div>
            <div className='download_buttons'>
              {/* <Button style={{marginBottom:10, marginLeft:20}} onClick={() => navigate('/admin/schoollist')}><KeyboardBackspaceIcon />Back</Button> */}
              <Button
                variant="outlined"
                onClick={() => window.open(url, '_blank')}
              >
                Download PDF
              </Button>
              <Button variant="outlined" onClick={() => navigate(-1)}><ArrowBackIcon />Back</Button>
            </div>
          </div>
          <div className='template_main'>
            <Stack direction={'row'}>
              <Image src={data?.admin_id?.logo} alt="Invoice Logo" width={'140px'} height={'80px'} />
              <Stack direction={'row'} spacing={1} className='template_main_date' sx={{ alignItems: 'center' }}>
                <Typography variant='body1' ><b>Invoice Date : </b></Typography>
                <Typography variant='body1' >{new Date(data?.createdAt).toLocaleDateString()}</Typography>
              </Stack>
            </Stack>
            <Stack>
              <div className='invoice_Billing'>
                <div className='invoice_Billing_to'>
                  <Typography variant='h3'>From</Typography>
                  <Typography variant='h4'>{data?.admin?.name ? data?.admin?.name : data?.admin_id?.name}</Typography>
                  <Typography variant='h4'>{data?.admin?.email ? data?.admin?.email : data?.admin_id?.email}</Typography>
                  <Typography variant='h4' style={{ lineHeight: '20px' }}>{data?.admin?.address ? data?.admin?.address : data?.admin_id?.address}</Typography>
                  <Typography variant='h4'>{data?.admin?.mobile_no ? data?.admin?.mobile_no : data?.admin_id?.mobile_no}</Typography>
                </div>
                <div className='invoice_Billing_to'>
                  <Typography variant='h3'>Billed To</Typography>
                  <Typography variant='h4'>{data?.driver?.name ? data?.driver?.name : data?.driver_id?.name}</Typography>
                  <Typography variant='h4'>{data?.driver?.email ? data?.driver?.email : data?.driver_id?.email}</Typography>
                  <Typography variant='h4' style={{ lineHeight: '20px' }}>{data?.driver?.address ? data?.driver?.address : data?.driver_id?.address}</Typography>
                  <Typography variant='h4'>{data?.driver?.mobile_no ? data?.driver?.mobile_no : data?.driver_id?.mobile_no}</Typography>
                </div>
                <div className='invoice_Billing_to_1'>
                  <Image src={data?.driver?.profile_pic} alt={"Profile Pic"} width={'100px'} height={'100px'} />
                </div>
              </div>
            </Stack>
            <div className='invoice_table'>
              <TableContainer>
                <Table sx={{ minWidth: 700 }} aria-label="spanning table">
                  <TableHead>
                    <TableRow>
                      <TableCell >
                        <div className='employee-name'>
                          Item's
                        </div>
                      </TableCell>
                      <TableCell align="right"><div className='employee-name'>Quantity</div></TableCell>
                      <TableCell align="right"><div className='employee-name'>Price</div></TableCell>
                      <TableCell align="right"><div className='employee-name'>Amount</div></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {products.map((row) => (
                      <TableRow key={row.desc}>
                        <TableCell>{row.desc}</TableCell>
                        <TableCell align="right">{row.qty}</TableCell>
                        <TableCell align="right">R {row.unit}</TableCell>
                        <TableCell align="right">R {ccyFormat(row.price)}</TableCell>
                      </TableRow>
                    ))}
                    <TableRow>
                      <TableCell rowSpan={3} />
                      <TableCell colSpan={2}>Total Amount</TableCell>
                      <TableCell align="right"><b>R</b> {ccyFormat(invoiceSubtotal)}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
        </section>
      </div>
    </>
  )
}

export default PdfTemplate